import axios from "axios";

export const publicClient = axios.create({
    baseURL: "https://rest.miview.shop/public",
    // baseURL: "http://localhost:8101",
    // withCredentials: true,
});

publicClient.interceptors.response.use(
    response => {
        return response;
    },
    // responseErrorInterceptor
);

export namespace PublicApis {
    export const getSpecialties = async () => {
        try {
            const ret = await publicClient.get(`/specialties`);
            console.log("[getSpecialties] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getSpecialties] error", e);
            throw e;
        }
    }

    export const getConcerns = async () => {
        try {
            const ret = await publicClient.get(`/concerns`);
            console.log("[getConcerns] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getConcerns] error", e);
            throw e;
        }
    }

    export const getParts = async () => {
        try {
            const ret = await publicClient.get(`/parts`);
            console.log("[getParts] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getParts] error", e);
            throw e;
        }
    }

    export const getTreatments = async () => {
        try {
            const ret = await publicClient.get(`/treatments`);
            console.log("[getTreatments] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getTreatments] error", e);
            throw e;
        }
    }

    export const getClinics = async () => {
        try {
            const ret = await publicClient.get(`/clinics`, { params: { limit: 10000 } });
            console.log("[getClinics] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getClinics] error", e);
            throw e;
        }
    }

    export const getClinic = async (clinicId) => {
        try {
            const ret = await publicClient.get(`/clinics/${clinicId}`);
            console.log("[getClinic] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getClinic] error", e);
            throw e;
        }
    }
}